<div class="grid-container margin-top">
    <report-command [dateRequired]="true" [fromDate]="fromDate" [toDate]="toDate" (reportGenerated)="generateReport($event)" (reportDownloaded)="downloadReport($event)"></report-command>
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="surplusInsurer" (firstDataRendered)="onGridPageChanged($event)" aria-label="Surplus Insurer Report"></ag-grid-angular>
</div>
